<div class="modal">
    <div class="container model-container {{context.customClass}}">
        <div class="modal-header">
            <div class="modal-result-image">
                <img [src]="context?.customImage || '/assets/icon/modal-success-image.svg'" alt="Success Icon">
            </div>
            <h4 class="header" *ngIf="context?.title">{{context.title}}</h4>
            <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon"
                width="32" height="32" alt="Close Icon" *ngIf="!context?.hideClose">
        </div>
        <div class="modal-body">
            <div class="modal-content">
                <div class="row">
                    <p class="modal-result-message">
                        {{context.message}}
                    </p>
                    <div *ngIf="!!context?.customHTML" [innerHTML]="context?.customHTML"></div>
                </div>
                <div class="row modal-actions">
                    <button class="button primary" (click)="done()">{{context.buttonText}}</button>
                </div>
            </div>
        </div>
    </div>
</div>